module.exports = __webpack_public_path__ + "static/media/oval.45ab83b3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/oval.svg
 ** module id = 135
 ** module chunks = 0
 **/